import "./eventsExport.scss";
import { IVeriTableRow, IVeriTableHeader } from "@directives/_veri/veriTable/veriTable.component";
import { IPlotEvent } from "@interfaces/IPlot";
import { VeriDate } from "@services/veriDate.service";
import { SortType } from "@enums/SortType";
import { VeriTableService } from "@directives/_veri/veriTable/veriTable.service";
import { TranslationService } from "@services/translation.service";
import { IDateFilter } from "@interfaces/filters/IDateFilter";
import { DateRange } from "@enums/DateRange.enum";

interface IComponentBindings {
    events: IPlotEvent[];
}

class ComponentController implements angular.IComponentController, IComponentBindings {
    tableRows: IVeriTableRow<any>[] = [];
    tableHeaders: IVeriTableHeader[] = [
        { title: this.translationService.t("eventsExport.time"), sortType: SortType.Date },
        { title: this.translationService.t("eventsExport.label") },
        { title: this.translationService.t("eventsExport.location") }
    ];

    events: IPlotEvent[];

    defaultDateRange: DateRange = DateRange.Today;
    dateFilter: IDateFilter;

    static $inject = ["veriDate", "veriTableService", "translationService"];

    constructor(
        private readonly veriDate: VeriDate,
        private readonly veriTableService: VeriTableService,
        private readonly translationService: TranslationService) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        this.dateFilter = this.veriDate.dateRangeFromEnum(this.defaultDateRange);
        this.updateEventsTable();

    }

    onDateFilterChanged(filter: IDateFilter): void {
        this.dateFilter = filter;
        this.updateEventsTable();
    }

    private updateEventsTable() {

        this.tableRows = [];

        if (this.events) {
            this.tableRows = this.createExportDataFromJourneyEvents(this.events);
        }
    }

    private createExportDataFromJourneyEvents(events: IPlotEvent[]): IVeriTableRow<any>[] {

        let startTimeMinutes = this.veriDate.parseTimeSpan(this.dateFilter.startTime ?? "00:00:00") / 60;
        let endTimeMinutes = this.veriDate.parseTimeSpan(this.dateFilter.endTime ?? "23:59:59") / 60;

        return this.veriTableService.createTableRowsWithCells(events.filter(e => {
            let eventTimeMinutes = this.veriDate.getMinuteOfDayFromDate(this.veriDate.createDate(e.Utc));
            return eventTimeMinutes >= startTimeMinutes && eventTimeMinutes <= endTimeMinutes
        }),
            (event) => {
                return [
                    this.veriTableService.createDateTimeCell(event.Utc),
                    { contents: event.label },
                    this.veriTableService.createLocationInformationCell(event.plot.Id, "row.data.plot", event.plot)
                ];
            },
            (event) => {
                return `${this.veriDate.formatDate(event.Utc)}${event.label}`;
            });
    }
}

export class EventsExportComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            events: "<"
        };

        this.controller = ComponentController;
        this.template = require("./eventsExport.html");
    }
}
